<template>
  <!-- eslint-disable max-len -->
  <div class="event-navigation-menu">
    <mj-drop-down ref="eventNavigationDropDown">
      <mj-button
        class="inline-flex items-center btn-naked focus:bg-indigo-800 ease-out transition-fastest transition-background-color origin-top-left"
        :class="{ 'cursor-auto' : !canUseDropdown}"
        @click="showCollabsibleContent"
      >
        {{ dropDownLabel }}
        <svg
          v-if="canUseDropdown"
          class="w-6 h-6 ml-2 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z" />
        </svg>
      </mj-button>
      <template
        v-if="canUseDropdown"
        #collapsible
      >
        <div class="w-64 overflow-hidden text-base font-semibold text-left text-gray-900 bg-white rounded-lg shadow-lg">
          <div
            v-if="hasMoreThanOneEvent && isSingleEventView"
            class="py-1 event-overview"
            @click="closeCollabsibleContent"
          >
            <router-link
              class="block px-6 py-3 leading-tight hover:bg-indigo-100"
              :to="{ name: 'event.overview'}"
              v-text="'Event Übersicht'"
            />
          </div>
          <div
            v-if="hasMoreThanOneEvent && !isSingleEventView"
            class="py-1 border-t-2 border-gray-200 events"
            @click="closeCollabsibleContent"
          >
            <router-link
              v-for="event in events"
              :key="event.id"
              class="block px-6 py-3 leading-tight hover:bg-indigo-100"
              :to="{ name: 'event.track.search', params: { id: event.id } }"
              v-text="event.name"
            />
          </div>
          <div
            v-if="isSingleEventView"
            class="py-1 border-t-2 border-gray-200 actions"
          >
            <button
              v-can="'edit events'"
              class="block w-full px-6 py-3 font-semibold text-left outline-none hover:bg-indigo-100 focus:outline-none"
              @click="show('update')"
            >
              Bearbeiten
            </button>
            <button
              v-can="'delete events'"
              class="block w-full px-6 py-3 font-semibold text-left outline-none hover:bg-indigo-100 focus:outline-none"
              @click="show('delete')"
            >
              Löschen
            </button>
          </div>
          <div
            v-can="'create events'"
            class="py-1 border-t-2 border-gray-200 actions"
          >
            <button
              class="block w-full px-6 py-3 font-semibold text-left outline-none hover:bg-indigo-100 focus:outline-none"
              @click="show('create')"
            >
              Neues Event erstellen
            </button>
          </div>
        </div>
      </template>
    </mj-drop-down>
  </div>
</template>
    </mj-drop-down>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropDown from '@/components/ui/general/dropdown/DropDown.vue';

export default {
  name: 'EventNavigationDropDownMenu',

  components: {
    'mj-drop-down': DropDown,
  },

  computed: {
    ...mapGetters(['events', 'currentEvent', 'isDefaultUser']),

    hasMoreThanOneEvent() {
      return this.events.length > 1;
    },

    canUseDropdown() {
      return this.isDefaultUser;
    },

    isSingleEventView() {
      return this.$route.fullPath.includes('event');
    },

    dropDownLabel() {
      if (this.isSingleEventView) {
        return this.currentEvent.name;
      }
      return 'Event Übersicht';
    },

  },

  methods: {
    showCollabsibleContent() {
      if (!this.canUseDropdown) return;
      this.$refs.eventNavigationDropDown.$data.isOpen = true;
    },

    closeCollabsibleContent() {
      this.$refs.eventNavigationDropDown.$data.isOpen = false;
    },

    show(mode) {
      const name = mode === 'delete' ? 'mj-event-delete-modal' : 'mj-event-save-modal';
      this.$modal.show('root-modal', { name, event: this.currentEvent, mode });
      this.closeCollabsibleContent();
    },
  },

};

</script>

<style lang="scss" scoped>

.btn-naked {
  @apply rounded-lg #{!important};
}

</style>
